var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "go-modal",
    {
      attrs: {
        id: "my-creates-askgoover-modal-detail",
        "dialog-class": "go-modal-askgoover-detail",
        "hide-footer": true,
      },
      on: { "modal:close": _vm.close },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function () {
            return [
              _c("div", { staticClass: "go-fixed-box" }, [
                _c("div", { staticClass: "go-btn-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.close.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              value: { customClass: "go-tooltip" },
                              expression: "{ customClass: 'go-tooltip' }",
                              modifiers: { hover: true },
                            },
                          ],
                          staticClass: "go-tooltip-area",
                          attrs: { title: _vm.$t("global.buttons.close") },
                        },
                        [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "go-btn-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.bookmark(_vm.localItem)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              value: {
                                placement: "topright",
                                customClass: "go-tooltip",
                              },
                              expression:
                                "{ placement: 'topright', customClass: 'go-tooltip' }",
                              modifiers: { hover: true },
                            },
                          ],
                          staticClass: "go-tooltip-area",
                          attrs: {
                            title: _vm.localItem.isBookmark
                              ? _vm.$t("my-create.ask-goover.un-bookmark")
                              : _vm.$t("my-create.ask-goover.bookmark"),
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "go-icon-24",
                            class: _vm.localItem.isBookmark
                              ? "go-icon-bookmark-on"
                              : "go-icon-bookmark-line",
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.share(_vm.localItem.conversationId)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              value: { customClass: "go-tooltip" },
                              expression: "{ customClass: 'go-tooltip' }",
                              modifiers: { hover: true },
                            },
                          ],
                          staticClass: "go-tooltip-area",
                          attrs: {
                            title: _vm.$t("global.menu.archives.share"),
                          },
                        },
                        [_c("i", { staticClass: "go-icon-24 go-icon-share" })]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _vm._v(" "),
      _c("ask-sub", {
        ref: "askGoover",
        attrs: {
          resourceIds: [],
          "reference-documents": _vm.getReferenceDocuments,
          page: "myCreate",
          showAddRefDropdown: true,
          "conversation-id": _vm.item.conversationId,
          "has-activity": true,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }